import Goo from "gooey-react";
import React from "react";

const CIRCLE_COUNT = 10;
const SPREAD = 30; // Radius spread percentage
const MIN_SIZE = 10; // Minimum circle size
const MAX_SIZE = 60; // Maximum circle size
const MIN_ROT_TIME = 3; // Minimum animation speed
const MAX_ROT_TIME = 6; // Maximum animation speed

function InkProgress({ size = 150 }) {
  const randSpeed = () =>
    Math.floor(Math.random() * (MAX_ROT_TIME - MIN_ROT_TIME)) + MIN_ROT_TIME;
  const randP = () => Math.floor(Math.random() * SPREAD) + (50 - SPREAD);
  const randR = () => Math.floor(Math.random() * (MAX_SIZE - MIN_SIZE)) + MIN_SIZE;
  const circles = Array.from({ length: CIRCLE_COUNT }, (_, index) => ({
    cx: randP() + "%",
    cy: randP() + "%",
    r: randR(),
    fill: "#000",
    animation: `${
      index > CIRCLE_COUNT / 2 ? "rotate" : "rotate_back"
    } ${randSpeed()}s linear infinite`,
  }));

  return (
    <Goo intensity="strong">
      <svg role="img" aria-label="Loading" style={{ height: size, width: size }}>
        <style>
          {`
            svg * { transform-origin: 50% }
            @keyframes rotate {
              0% { }
              100% { transform: rotate(360deg) }
            }

            @keyframes rotate_back {
              0% { }
              100% { transform: rotate(-360deg) }
            }
          `}
        </style>
        <g>
          {circles.map((circle, index) => (
            <circle
              key={index}
              cx={circle.cx}
              cy={circle.cy}
              r={circle.r}
              fill={circle.fill}
              style={{
                animation: circle.animation,
              }}
            />
          ))}
        </g>
      </svg>
    </Goo>
  );
}

export default InkProgress;
